"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanRecord = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jyEduStages_1 = require("../../model/jyEduStages");
var service_1 = require("../../../library/base/service");
var LoanRecord = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LoanRecord, _super);
    function LoanRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '借款记录接口';
        _this.code = '101101';
        _this.desc = '借款记录接口';
        _this.requestParams = new jyEduStages_1.LoanRecordRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LoanRecord;
}(service_1.BaseService));
exports.LoanRecord = LoanRecord;
//# sourceMappingURL=loanRecord.js.map